export default __webpack_public_path__ + "images/256x145@2x.35f61fa5d772137e4a8b2625a022806d.jpg";